import moment from 'moment';

import { isString, isUndefined } from '../../../utils/isDefined';

export default function checkIfExpired(data) {
  if (data.name === 'default') {
    return false;
  }
  const now = moment();

  const { eventSchedule } = data;

  if (isUndefined(eventSchedule)) {
    return false;
  }

  if (
    eventSchedule.recurrenceType === 'NONE' ||
    eventSchedule.recurrenceType === 'DAILY' ||
    eventSchedule.recurrenceType === 'WEEKLY'
  ) {
    if (
      isUndefined(eventSchedule.end?.date) ||
      isUndefined(eventSchedule.end?.time)
    ) {
      return false;
    }
    const toDate = moment(eventSchedule.end.date);

    if (moment(toDate).isBefore(now, 'day')) {
      return true;
    } else {
      if (moment(toDate).isSame(now, 'day')) {
        const nowTime = now.format('HH:mm');
        const toTime = moment(eventSchedule.end.time)
          .tz('UTC')
          .format('HH:mm');

        return checkIfTimeExpired(nowTime, toTime);
      }
    }
    return false;
  }

  if (
    eventSchedule.recurrenceType === 'MONTHLY_ABSOLUTE' ||
    eventSchedule.recurrenceType === 'YEARLY_ABSOLUTE' ||
    eventSchedule.recurrenceType === 'MONTHLY' ||
    eventSchedule.recurrenceType === 'YEARLY'
  ) {
    if (isUndefined(eventSchedule.recurrenceEnd?.value)) {
      return false;
    }
    const endDate = moment(Number(eventSchedule.recurrenceEnd?.value));

    if (moment(endDate).isBefore(now, 'day')) {
      return true;
    }
    return false;
  }

  return false;
}

function checkIfTimeExpired(nowTime, endTime) {
  if (!isString(nowTime) || !isString(endTime)) {
    return false;
  }

  const [nowH, nowM] = nowTime.split(':');
  const [endH, endM] = endTime.split(':');

  if (Number(nowH) > Number(endH)) {
    return true;
  } else {
    if (Number(nowH) === Number(endH)) {
      if (Number(nowM) > Number(endM)) {
        return true;
      }
      return false;
    }
  }
}
